import { name } from "./block.json";

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLElement) {
	const innerElement = block.querySelector<HTMLElement>('.wp-block-site-specifics-content__inner');
	const innerBlocksContainerElement = block.querySelector<HTMLElement>('.wp-block-site-specifics-content__innerblocks-container');

	if (!innerElement || !innerBlocksContainerElement) {
		return;
	}

	const sizeChange = () => {
		let elementHeight = innerBlocksContainerElement.offsetHeight;
		elementHeight += parseInt(window.getComputedStyle(innerBlocksContainerElement).getPropertyValue('margin-top'));
		elementHeight += parseInt(window.getComputedStyle(innerBlocksContainerElement).getPropertyValue('margin-bottom'));

		innerElement.style.height = elementHeight + 'px';
	}

	new ResizeObserver(sizeChange).observe(innerBlocksContainerElement);
}
